/* eslint-disable import/no-extraneous-dependencies */
import {
  downloadCertificates,
  downloadReports,
  downloadKnowledgePortal,
} from 'services/claimsService';
import axios from 'axios';
import JSZip from 'jszip';
import saveAs from 'file-saver';
import { downloadFile } from './downloadFile';

export const getCertificatesUrls = async (
  ids,
  cpId,
  franshiceCode,
  bucketKey?,
  idCertificate?,
) => {
  const { data } = await downloadCertificates(
    ids,
    cpId,
    franshiceCode,
    bucketKey,
    idCertificate,
  );
  return data.response;
};

export const getReportsUrls = async (
  ids,
  cpId,
  franshiceCode,
  bucketKey?,
  idReport?,
) => {
  const { data } = await downloadReports(
    ids,
    cpId,
    franshiceCode,
    bucketKey,
    idReport,
  );
  return data.response;
};

export const getPortalUrls = async (
  ids,
  cpId,
  franshiceCode,
  bucketKey?,
  idReport?,
) => {
  const { data } = await downloadKnowledgePortal(
    ids,
    cpId,
    franshiceCode,
    bucketKey,
    idReport,
  );
  return data.response;
};

export function downloadOneFile(file) {
  downloadFile(file.fileUrl, file.fileName);
}

export function downloadOneFilePortal(file) {
  downloadFile(file.url, file.fileName);
}

export async function download(fileUrl, fileName, idCertificate) {
  try {
    const resp = await axios.get(fileUrl, { responseType: 'blob' });
    return { fileName, idCertificate, data: resp.data };
  } catch (err) {
    console.log(`Erro ao fazer download do arquivo ${fileName}:`, err);
    return null;
  }
}

export async function downloadAll(files) {
  try {
    const zip = new JSZip();
    const arrOfPromises = files.map(item =>
      download(item.fileUrl, item.fileName, item.idCertificate),
    );
    const arrOfFiles = await Promise.all(arrOfPromises);
    arrOfFiles.forEach(file => {
      if (file) {
        zip.file(`${file.idCertificate}-${file.fileName}`, file.data);
      }
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    saveAs(blob, 'certificados.zip');
  } catch (err) {
    console.log(err);
  }
}

export async function downloadAllReports(files) {
  try {
    const zip = new JSZip();
    const arrOfPromises = files.map(item =>
      download(item.fileUrl, item.fileName, item.idCertificate),
    );
    const arrOfFiles = await Promise.all(arrOfPromises);
    arrOfFiles.forEach(file => {
      if (file) {
        zip.file(`${file.idReport}-${file.fileName}`, file.data);
      }
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    saveAs(blob, 'relatorios.zip');
  } catch (err) {
    console.log(err);
  }
}

export async function downloadAllPortalFiles(files) {
  console.log('files', files);
  try {
    const zip = new JSZip();
    const arrOfPromises = files.map(item =>
      download(item.url, item.fileName, item.id),
    );
    console.log('arrOfPromises', arrOfPromises);
    const arrOfFiles = await Promise.all(arrOfPromises);
    console.log('arrOfFiles', arrOfFiles);
    arrOfFiles.forEach(file => {
      if (file) {
        zip.file(`${file.fileName}`, file.data);
      }
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    saveAs(blob, 'arquivos.zip');
  } catch (err) {
    console.log(err);
  }
}
